import { render, staticRenderFns } from "./testSet.vue?vue&type=template&id=180a2126&scoped=true&"
import script from "./testSet.vue?vue&type=script&lang=js&"
export * from "./testSet.vue?vue&type=script&lang=js&"
import style0 from "./testSet.vue?vue&type=style&index=0&id=180a2126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a2126",
  null
  
)

export default component.exports